/// <reference path='../../_references.ts' />
module onvio.setup.importWizard {
    'use strict';

    export class ImportWizardController {
        static $inject = [
            '$state',
        ];
        constructor(
            private $state: ng.ui.IStateService) { }

        openProgressPage() {
            this.$state.go('setup-import-progress');
        }
    }

    angular.module('onvio.setup.importWizard', [])
        .controller('ImportWizardController', ImportWizardController);
}